module.exports = __webpack_public_path__ + "static/img/Hugh-McCluggage.b2c6db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hugh-McCluggage.jpg
// module id = jCv9
// module chunks = 0